import { useEffect, useState } from 'react';
import { FEATURE_DEFAULT, type Feature, type FeatureMap } from 'shared';
import { api } from './api';

/**
 * Доступные функции.
 *
 * Загружается один раз на сессию и кэшируется в модуле: набор меняется
 * администратором, а не в рантайме, и дёргать сервер на каждом экране незачем.
 * До ответа считаем всё включённым — иначе интерфейс моргает пустотой.
 */
let cache: FeatureMap | null = null;
const waiters = new Set<(m: FeatureMap) => void>();

export function useFeatures(): FeatureMap {
  const [map, setMap] = useState<FeatureMap>(cache ?? FEATURE_DEFAULT);

  useEffect(() => {
    if (cache) return;

    const onReady = (m: FeatureMap) => setMap(m);
    waiters.add(onReady);

    api
      .features()
      .then((m) => {
        cache = m;
        for (const w of waiters) w(m);
        waiters.clear();
      })
      .catch(() => {});

    return () => {
      waiters.delete(onReady);
    };
  }, []);

  return map;
}

export function useFeature(name: Feature): boolean {
  return useFeatures()[name];
}

/** Сброс кэша — после смены правил в админке. */
export function resetFeatures() {
  cache = null;
}
